import React, { useState, useEffect } from 'react';
import { setTitle } from "../helpers/MetaTag";
import Select from '../components/form/Select';
import Image from '../components/elements/Image';
import Textarea from '../components/form/Textarea';
import Button from '../components/form/Button';
import Searching from '../components/Searching';
import NoDataFound from '../components/NoDataFound';
import toastr from 'toastr';
import { PDFDownloadLink,Document } from '@react-pdf/renderer';
import { useSelector } from 'react-redux';
import BoardMemberConclusionReport from './pdf/BoardMemberConclusionReport';
import BoardMemberOtherEmployeePopup from '../components/popup/BoardMemberOtherEmployeePopup';
import DropdownCheckbox from '../components/form/DropdownCheckbox';
import AlertPopup from '../components/popup/AlertPopup';
import { useNavigate } from "react-router-dom";
import { API_URL } from '../config/host';
import OtherCommitteePopup from '../components/popup/OtherCommitteePopup';
import BoardMemberReadinessReport from './pdf/BoardMemberReadinessReport';

import { postData } from '../services/api';
import { useTranslation } from "react-i18next";

const BoardMamberReadiness = ({
  getIsChange = () => {}
}) => {
  setTitle("Succession Now | Board Member Readiness");
  const { i18n,t } = useTranslation();
  const role =  localStorage.getItem("role");
  const user = useSelector((state) => state.auth?.user)
  const navigate = useNavigate();
  const [timeFrame, setTimeFrame] = useState([]);
  const [neededdevelopments, setNeededdevelopments] = useState([]);
  const [committeefits,setCommitteefits] = useState([]);
  const [positionDetails,setPositionDetails] = useState({});
  const [loading, setLoading] = useState(true);
  const [keyword, setKeyword] = useState("");
  const [limit, setLimit] = useState(10000);
  const [offset, setOffset] = useState(0);
  const [noOfPage, setNoOfPage] = useState(0);
  const [boardMember, setBoardMember] = useState([]);
  const [totalDataCount, setTotalDataCount] = useState(0);
  const [isNextStep,setIsNextStep] = useState(false);
  const [isChange,setIsChage] = useState(false);

  const [predictorWeight,setPredictorWeight] =  useState(0);
  const [experienceWeight,setExperienceWeight] =  useState(0);
  const [concernsWeight,setConcernWeight] =  useState(0);
  const [performanceWeight,setPerformanceWeight] =  useState(0);
  const [educationWeight,setEducationWeight] =  useState(0);
  const [totalWeight,setTotalWeight] = useState(0);
  const [isUpdate, setIsUpdate] = useState(false);

  const [enabledAlertPopup, setEnabledAlertPopup] = useState(false);
  const [actionValue, setActionValue] = useState({});
  const [message,setMessage] = useState('');
  const [fileldData,setFileldData] = useState({});

  const [enabledOtherCommitteePopup,setEnabledOtherCommitteePopup] = useState(false);
  const [commitDetails,setCommitDetails] = useState({});


  useEffect(()=>{
    if(role && (role !== 'customer-admin')){
      return navigate("/dashboard");
    }
  },[role])

  // const heading = [
  //   {
  //     name: t('readiness_timeframe'),
  //     option: "",
  //   },
  //   {
  //     name: t('needed_development'),
  //     option: "",
  //   },
  //   {
  //     name: t('potential_committee_assignments'),
  //     option: "",
  //   },
  //   {
  //     name: t('additional_comments'),
  //     option: "",
  //   },
  //   // {
  //   //   name : t('eliminated_candidate_due_to'),
  //   //   option: ''
  //   // }
  // ];

  useEffect(() => {
    async function timeFrameData() {
      try {
        const result = await postData("time-frame/list", {
          sortQuery: { created_at: 1 },
          type: 1,
          status: 1,
          type : 1
        });
        if (result.data) {
          setTimeFrame(result.data);
        } else {
          console.log("Time Frame list message", result.message);
        }
      } catch (error) {
        console.log("Error time frame list catch", error.message);
      }
    }
    timeFrameData();

    async function neededDevelopmentList() {
      try {
        const result = await postData("needed-development/list", {
            sortQuery:{'created_at':1},
            type : 2,
            status:1,
        });
        if (result.data) {
          setNeededdevelopments(result.data);
        } else {
          console.log('Needed development message',result.message)
        }
      } catch (error) {
        console.log('Error needed development catch',error.message)
      }
    }
    neededDevelopmentList();

    async function committeeFitData() {
      try {
        const result = await postData("committee-fit/list", {
          sortQuery: { created_at: 1 },
          status: 1,
        });
        if (result.data) {
          setCommitteefits(result.data);
        } else {
          console.log("Committee fit list message", result.message);
        }
      } catch (error) {
        console.log("Error committee fit list catch", error.message);
      }
    }
    committeeFitData();

    async function positionDetails() {
      try {
        const result = await postData("competency/details", {
          id: user.designation,
        });
        if (result.data) {
          setPositionDetails(result.data);
        } else {
          console.log("Competency details message", result.message);
        }
      } catch (error) {
        console.log("Error competency details catch", error.message);
      }
    }
    positionDetails();
  },[])

  useEffect(() => {
    // Advancement List
    const loadBoardMembers = async () => {
      setLoading(true);
      try {
        const result = await postData("board-member/list", {    
          keyword: keyword,
          limit: limit,
          offset: offset,      
          sortQuery: { created_at: 1 }
        });
        if (result.data) {
          setBoardMember(result.data);          
        }
        setTotalDataCount(result.count);
        setLoading(false);
      } catch (err) {
        setLoading(false);
        console.log(err.message);
      }
    };
    loadBoardMembers();
  }, [keyword, limit, offset, timeFrame, neededdevelopments,isUpdate]);

  useEffect(() => {
    setNoOfPage(Math.ceil(totalDataCount / limit));
  }, [limit, totalDataCount]);

  const handlePageClick = (event) => {
    const newOffset = (event.selected * limit) % totalDataCount;
    console.log(
      `User requested page number ${event.selected}, which is offset ${newOffset}`
    );
    setOffset(newOffset);
  };

  const handelUpdate = async (id, val, field, index,oldValue='') => {
    try {
      setIsChage(false);
      getIsChange(false);
      if(field === 'time_frame'){
        const index1 = timeFrame.findIndex((item) => item._id === val);
        const index2 = boardMember.findIndex((item) => item._id === id);
        if(index1 !== -1){
          if(timeFrame[index1].isConfirm && boardMember[index2].overallWeightScore < 4){
            setFileldData({
              id:id,
              val : val,
              field : field
            })
            setEnabledAlertPopup(true);
            setMessage(timeFrame[index1].confirmMessage);
            return;
          }
        }
      }
      setBoardMember(
        boardMember.map((it, idx) => {
          if (idx === index) {
            return { ...it, [field]: val };
          } else {
            return it;
          }
        })
      );
      const result = await postData("board-member/update", {
        id: id,
        [field]: val !== "" ? val : null,
      });
      if (result.status && result.status === 200) {
        toastr.success(result.message);
        //await postData("download-succession-plan/close-approval", {});
        setIsChage(true);
        getIsChange(true);
      } else {
        toastr.error(result.message);
        setIsChage(true);
        getIsChange(true);
      }
    } catch (error) {
      toastr.error(error.message);
      setIsChage(true);
      getIsChange(true);
    }
  };

  const handelSetText = async (id, val, field, index) => {
    setBoardMember(
      boardMember.map((it, idx) => {
        if (idx === index) {
          return { ...it, [field]: val };
        } else {
          return it;
        }
      })
    );
  }

  const handelUpdateText = async (id, val, field, index) => {
    try {
      setBoardMember(
        boardMember.map((it, idx) => {
          if (idx === index) {
            return { ...it, [field]: val };
          } else {
            return it;
          }
        })
      );
      const result = await postData("board-member/update", {
        id: id,
        [field]: val,
      });
      if (result.status && result.status === 200) {
        toastr.success(result.message);
        //await postData("download-succession-plan/close-approval", {});
      } else {
        toastr.error(result.message);
      }
    } catch (error) {
      toastr.error(error.message);
    }
  };  

  useEffect(() => {
    if (actionValue && actionValue.button_type === "confirm") {
      const updateRecord = async () => {
        setIsUpdate(false)
        try {
            const result = await postData("board-member/update", {
              id: actionValue?.data?.id,
              [actionValue?.data?.field]: actionValue?.data?.val !== "" ? actionValue?.data?.val : null,
            });
            if (result.status && result.status === 200) {
              toastr.success(result.message);
              setEnabledAlertPopup(false);
              setMessage(''); 
              setFileldData({});
            } else {
              toastr.error(result.message);
              setEnabledAlertPopup(false);
              setMessage(''); 
              setFileldData({})
            }
            setIsUpdate(true)
        } catch (error) {
            toastr.error(error.message);
        }
      };
      updateRecord(); 
    }else if (actionValue && actionValue.button_type === "committee_add") {
      setCommitteefits([...committeefits,actionValue?.result])
      setBoardMember(
        boardMember.map((it, idx) => {
          if (idx === commitDetails?.index) {
            return { ...it, [commitDetails?.field]: commitDetails?.val };
          } else {
            return it;
          }
        })
      );
      const _updateRecord = async  () => {
        setIsUpdate(false)
        try {
          const result = await postData("board-member/update", {
            id: commitDetails?.id,
            [commitDetails?.field]: actionValue?.val !== "" ? actionValue?.row_id : null,
          });
          if (result.status && result.status === 200) {
            toastr.success(result.message);
            setIsUpdate(true)
          } else {
            toastr.error(result.message);
            setIsUpdate(true)
          }
        } catch (error) {
          toastr.error(error.message);
          setIsUpdate(true)
        }
      }
      _updateRecord();
    }
  }, [actionValue]);


  const getDownload = (e) => {
    e.preventDefault();
    if (e.target.tagName.toLowerCase() === "a") {
      window.open(e.target.href,'_blank');
    }
  }  

  const getInitials = function (string) {
    var names = string.split(' '),
        initials = names[0].substring(0, 1).toUpperCase();    
    if (names.length > 1) {
        initials += names[names.length - 1].substring(0, 1).toUpperCase();
    }
    return initials;
  };
  

  return (
  <>
      <div className="relative flex justify-between items-center mb-4 flex-wrap sm:flex-nowrap gap-y-4">
        <div className="text-xl md:text-3xl text-slate-800 font-bold">{t('board_member_readiness')}</div>
      <div className="sm:ml-auto flex justify-end items-center space-x-2">        
        {/* <button
          type={'button'}
          className={"flex justify-center items-center gap-2 bg-teal-500 text-white rounded text-lg h-10 py-0 px-3 transition-all duration-200 cursor-pointer "}
          onClick={(e) => getDownload(e)}
        >
          <i className={"fa-fw fa-light fa-download"}></i>
          <div className={"text-sm font-medium whitespace-nowrap"}>
            <PDFDownloadLink document={
            <BoardMemberReadinessReport 
            boardMembers={boardMember} 
            user={user} 
            />} fileName="profile_report.pdf">
              {({ blob, url, loading, error }) => (
                loading ? t('loading_document') : t('report'))}
            </PDFDownloadLink>
          </div>
        </button>*/}
      </div>
    </div>
    <div className="relative flex justify-between items-center mb-4">
        
    </div>
    <div className="w-full overflow-auto scroll-smooth scrollbar bg-white rounded-md shadow min-h-[480px]">
      <table className="min-w-max w-full table-auto">
        <thead>
          <tr className="text-white font-bold text-sm leading-none border-b border-slate-200">
            <th className="py-6 px-2 text-left max-w-[240px] sticky -top-6 z-10 bg-slate-900 rounded-tl-md">&nbsp;</th>
            <th className="py-6 px-2 text-left max-w-[240px] sticky -top-6 z-10 bg-slate-900">{t('readiness_timeframe')}</th>
            <th className="py-6 px-2 text-left max-w-[240px] sticky -top-6 z-10 bg-slate-900">{t('needed_development')}</th>
            <th className="py-6 px-2 text-left max-w-[240px] sticky -top-6 z-10 bg-slate-900">{t('potential_committee_assignments')}</th>
            <th className="py-6 px-2 text-left max-w-[240px] sticky -top-6 z-10 bg-slate-900 rounded-tr-md">{t('additional_comments')}</th>
          </tr>
        </thead>
        <tbody className="text-slate-700 text-sm font-light">
        {
          totalDataCount > 0 ? (
            boardMember.map((item,index) => {              
            return (
              <tr className="border-b border-slate-200" key={item._id}>
                <td className="py-3 px-2 text-left max-w-[240px]">
                  <div className="block">
                    <div className="text-sm font-medium text-slate-600">{item.first_name+' '+item.last_name}</div>
                    {/* <div className="text-xs text-slate-400">{item?.position_details?item?.position_details[0]?.short_name:"N/A"}</div> */}
                  </div>
                </td>                  
                <td className="py-3 px-2 text-left max-w-[240px]">
                  <Select
                    xPlacement={"left"}
                    selectedValue={item?.time_frame}
                    dropdownClass={"!w-60"}
                    dropdownButtonLabelClass={"!font-bold"}
                    dropdownData={[
                      { _id: "", label: t('select'), value: "" },
                      ...timeFrame.map((frame_item) => ({
                        _id: frame_item?._id,
                        label: frame_item?.name,
                        value: frame_item?._id,
                      })),
                    ]}
                    dropdownOptionBold={true}
                    getSelectedValue={(e) =>
                      handelUpdate(
                        item._id,
                        e._id,
                        "time_frame",
                        index,
                        item?.time_frame
                      )
                    }
                  />
                </td>
                <td className="py-3 px-2 text-left max-w-[240px]">
                  <Select
                    xPlacement={"left"}
                    selectedValue={item?.readiness_needed_development}
                    dropdownClass={"!w-60"}
                    dropdownData={[
                      { _id: "", label: t('select'), value: "" },
                      ...neededdevelopments.map((fit_item) => ({
                        _id: fit_item?._id,
                        label: fit_item?.name,
                        value: fit_item?._id,
                      })),
                    ]}
                    dropdownButtonLabelClass={"!font-bold"}
                    dropdownOptionBold={true}
                    getSelectedValue={(e) =>
                      handelUpdate(
                        item._id,
                        e._id,
                        "readiness_needed_development",
                        index
                      )
                    }
                  />
                </td>
                <td className="py-3 px-2 text-left max-w-[240px]">
                  <Select
                    xPlacement={"left"}
                    selectedValue={item?.committee_fit}
                    dropdownClass={"!w-60"}
                    dropdownData={[
                      { _id: "", label: t('select'), value: "" },
                      ...committeefits.map((fit_item) => ({
                        _id: fit_item?._id,
                        label: fit_item?.name,
                        value: fit_item?._id,
                      })),
                      { _id: "others-committee", label: t('other_committee'), value: ""}
                    ]}
                    dropdownButtonLabelClass={"!font-bold"}
                    dropdownOptionBold={true}
                    getSelectedValue={(e) => {
                        if(e._id === 'others-committee'){
                          setEnabledOtherCommitteePopup(true);
                          setCommitDetails({
                            id:item._id, 
                            val:e._id, 
                            field:"committee_fit", 
                            index:index
                          })
                        }else{
                          handelUpdate(
                            item._id,
                            e._id,
                            "committee_fit",
                            index
                          )
                        }
                      } 
                    }
                  />
                </td>
                <td className="py-3 px-2 text-left max-w-[240px]">
                  <Textarea
                    inputClasses={"!h-32"}
                    inputValue={item?.advancement_additional_comments}
                    setTextarea={(val) =>
                      handelSetText(
                        item._id,
                        val,
                        "advancement_additional_comments",
                        index
                      )
                    }
                    onBlur={(val) =>
                      handelUpdateText(
                        item._id,
                        val,
                        "advancement_additional_comments",
                        index
                      )
                    }
                  />
                </td>
              </tr>
            )
          })
          ):(
            <tr className="border-b border-slate-200">
              <td className="py-3 px-2 text-left" colSpan={20}>
                {loading ? <Searching label={'Searching'}/> : <NoDataFound label={'No Data Found'}/>}
              </td>
            </tr>
          )}
        </tbody>
      </table>
    </div>
    {/* <div className="w-full scroll-smooth scrollbar min-h-[480px] mb-4">
      <table className="min-w-max w-full table-auto">
        <thead>
          <tr className="text-white font-bold text-sm leading-none border-b border-slate-200">
            <th className="py-4 px-2 text-left max-w-[240px] sticky -top-6 z-10 bg-slate-900 rounded-tl-md"></th>
            {totalDataCount > 0
              ? boardMember.map((item, index) => {
                let namelatter = getInitials(item.first_name+' '+item.last_name);
                  return (
                    <th className="py-4 px-2 max-w-[240px] align-top sticky -top-6 z-10 bg-slate-900 last:rounded-tr-md">
                      <div className="flex justify-center gap-1">
                        <div className="mx-auto flex justify-center gap-4 items-center">
                          <div className="w-8 h-8 min-w-[32px] min-h-[32px] overflow-hidden rounded-full relative">
                            <Image
                              src={API_URL+item?.image}
                              alt={"Admin"}
                              width={"100%"}
                              height={"100%"}
                              effect={"blur"}
                              classes={"object-cover cursor-pointer"}
                            />                            
                          </div>
                          <div className='w-8 h-8 min-w-[32px] min-h-[32px] overflow-hidden rounded-full relative flex items-center justify-center border border-white'>
                            {namelatter}
                          </div>
                          <div className="font-semibold text-sm leading-none text-center">
                            {item.first_name+' '+item.last_name}
                            <span className="block text-[11px] font-medium mt-1">
                              {item?.position_details
                                ? item?.position_details?.short_name
                                : "N/A"}
                            </span>
                            <span className="block text-[11px] font-medium mt-1">
                              {item?.overallWeightScore
                                ? '('+item?.overallWeightScore+')'
                                : "(0)"}
                            </span>
                          </div>
                        </div>
                      </div>
                    </th>
                  );
                })
              : ""}
          </tr>
        </thead>
        <tbody className="text-slate-700 text-sm font-light bg-white">
          {heading.map((items, index) => (
            <tr className="border-b border-slate-200" key={index}>
              <td className="py-3 px-2 font-semibold text-sm text-left max-w-[240px] align-top">
                {items.name}
                <span className="block text-xs font-normal leading-tight text-slate-500 my-1">
                  {items.option}
                </span>
              </td>
              {totalDataCount > 0 ? (
                boardMember.map((item, index1) => {
                  if (index === 0) {
                    return (
                      <td className="py-3 px-2 text-left max-w-[240px]">
                        <Select
                          xPlacement={"left"}
                          selectedValue={item?.time_frame}
                          dropdownClass={"!w-60"}
                          dropdownButtonLabelClass={"!font-bold"}
                          dropdownData={[
                            { _id: "", label: t('select'), value: "" },
                            ...timeFrame.map((frame_item) => ({
                              _id: frame_item?._id,
                              label: frame_item?.name,
                              value: frame_item?._id,
                            })),
                          ]}
                          dropdownOptionBold={true}
                          getSelectedValue={(e) =>
                            handelUpdate(
                              item._id,
                              e._id,
                              "time_frame",
                              index1,
                              item?.time_frame
                            )
                          }
                        />
                      </td>
                    );
                  } else if (index === 1) {
                    return (
                      <td className="py-3 px-2 text-left max-w-[240px]">
                        <Select
                          xPlacement={"left"}
                          selectedValue={item?.readiness_needed_development}
                          dropdownClass={"!w-60"}
                          dropdownData={[
                            { _id: "", label: t('select'), value: "" },
                            ...neededdevelopments.map((fit_item) => ({
                              _id: fit_item?._id,
                              label: fit_item?.name,
                              value: fit_item?._id,
                            })),
                          ]}
                          dropdownButtonLabelClass={"!font-bold"}
                          dropdownOptionBold={true}
                          getSelectedValue={(e) =>
                            handelUpdate(
                              item._id,
                              e._id,
                              "readiness_needed_development",
                              index1
                            )
                          }
                        />
                      </td>
                    );
                  } else if (index === 2) {
                    return (
                      <td className="py-3 px-2 text-left max-w-[240px]">
                        <Select
                          xPlacement={"left"}
                          selectedValue={item?.committee_fit}
                          dropdownClass={"!w-60"}
                          dropdownData={[
                            { _id: "", label: t('select'), value: "" },
                            ...committeefits.map((fit_item) => ({
                              _id: fit_item?._id,
                              label: fit_item?.name,
                              value: fit_item?._id,
                            })),
                            { _id: "others-committee", label: t('other_committee'), value: ""}
                          ]}
                          dropdownButtonLabelClass={"!font-bold"}
                          dropdownOptionBold={true}
                          getSelectedValue={(e) => {
                              if(e._id === 'others-committee'){
                                setEnabledOtherCommitteePopup(true);
                                setCommitDetails({
                                  id:item._id, 
                                  val:e._id, 
                                  field:"committee_fit", 
                                  index:index1
                                })
                              }else{
                                handelUpdate(
                                  item._id,
                                  e._id,
                                  "committee_fit",
                                  index1
                                )
                              }
                            } 
                          }
                        />
                      </td>
                    );
                  } else if (index === 3) {
                    return (
                      <td className="py-3 px-2 text-left max-w-[240px]">
                        <Textarea
                          inputClasses={"!h-32"}
                          inputValue={item?.advancement_additional_comments}
                          setTextarea={(val) =>
                            handelSetText(
                              item._id,
                              val,
                              "advancement_additional_comments",
                              index1
                            )
                          }
                          onBlur={(val) =>
                            handelUpdateText(
                              item._id,
                              val,
                              "advancement_additional_comments",
                              index1
                            )
                          }
                        />
                      </td>
                    );
                  } else if(index === 4) {
                    return(
                      <td className="py-3 px-2 text-left max-w-[240px]">
                        {                          
                          (item.desireResult && item.desireResult === 2) &&
                            <div className="block text-xs font-semibold leading-tight text-rose-500 my-1">{item?.desire_details[0]?.name}</div>
                        }
                        {
                          (item.loyaltyResult && item.loyaltyResult === 2) &&
                            <div className="block text-xs font-semibold leading-tight text-rose-500 my-1">{item?.loyalty_details[0]?.name}</div>
                        }
                        {
                          (item.RetirementResult && item.RetirementResult === 2) &&
                            <div className="block text-xs font-semibold leading-tight text-rose-500 my-1">{item?.retirement_details[0]?.name}</div>
                        }
                      </td>
                    )
                  } else {
                    return (
                      <td className="py-3 px-2 text-left max-w-[240px] align-top">
                        <div className="relative flex justify-center text-xs font-medium text-slate-700 bg-white py-2 px-3 border border-slate-200 rounded"></div>
                      </td>
                    );
                  }
                })
              ) : ''}
            </tr>
          ))}
        </tbody>
      </table>
    </div> */}
    {enabledAlertPopup && (
      <AlertPopup
        isOpen={enabledAlertPopup}
        setIsOpen={(val) => setEnabledAlertPopup(val)}
        data={fileldData}
        getActionValue={(obj) => {
          setActionValue(obj);
        }}
        message={message}
      ></AlertPopup>
    )}
    {enabledOtherCommitteePopup && (
        <OtherCommitteePopup
          isOpen={enabledOtherCommitteePopup}
          setIsOpen={(val) => setEnabledOtherCommitteePopup(val)}
          data={commitDetails}
          getActionValue={(obj) => {
            setActionValue(obj);
          }}
        ></OtherCommitteePopup>
    )}
  </>
  );
};

export default BoardMamberReadiness;